import { render } from "./InfoGridRank2.vue?vue&type=template&id=69f5021c&scoped=true"
import script from "./InfoGridRank2.vue?vue&type=script&lang=js"
export * from "./InfoGridRank2.vue?vue&type=script&lang=js"

import "./InfoGridRank2.vue?vue&type=style&index=0&id=69f5021c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69f5021c"]])

export default __exports__